export default __webpack_public_path__ + "static/media/woman@3x.8109da2c.png";